import { useTranslation } from 'react-i18next'
import { Card, CardHeader, CardTitle, CardContent } from '@/components/ui/card'
import { ProcessorDetails } from '@/lib/api/processors'

interface MastercardDescriptorCardProps {
    processor: ProcessorDetails
}

const getDescriptor = (options: Record<string, unknown> | null) => {
    return options?.descriptor as {
        descriptor?: string
        phone?: string
        address?: string
        city?: string
        state?: string
        postal?: string
        country?: string
    } | undefined
}

export const MastercardDescriptorCard = ({ processor }: MastercardDescriptorCardProps) => {
    const { t } = useTranslation('processors')
    const descriptor = getDescriptor(processor.options)

    if (!descriptor || Object.keys(descriptor).length === 0) {
        return null
    }

    return (
        <Card className="mb-6">
            <CardHeader>
                <CardTitle>{t('descriptorSettings')}</CardTitle>
            </CardHeader>
            <CardContent>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                    {descriptor.descriptor && (
                        <div>
                            <p className="text-sm text-muted-foreground">{t('statementDescriptor')}</p>
                            <p className="font-semibold">{descriptor.descriptor}</p>
                        </div>
                    )}

                    {descriptor.phone && (
                        <div>
                            <p className="text-sm text-muted-foreground">{t('phone')}</p>
                            <p className="font-semibold">{descriptor.phone}</p>
                        </div>
                    )}

                    {descriptor.address && (
                        <div className="col-span-full">
                            <p className="text-sm text-muted-foreground">{t('address')}</p>
                            <p className="font-semibold">{descriptor.address}</p>
                        </div>
                    )}

                    {descriptor.city && (
                        <div>
                            <p className="text-sm text-muted-foreground">{t('city')}</p>
                            <p className="font-semibold">{descriptor.city}</p>
                        </div>
                    )}

                    {descriptor.state && (
                        <div>
                            <p className="text-sm text-muted-foreground">{t('state')}</p>
                            <p className="font-semibold">{descriptor.state}</p>
                        </div>
                    )}

                    {descriptor.postal && (
                        <div>
                            <p className="text-sm text-muted-foreground">{t('postalCode')}</p>
                            <p className="font-semibold">{descriptor.postal}</p>
                        </div>
                    )}

                    {descriptor.country && (
                        <div>
                            <p className="text-sm text-muted-foreground">{t('country')}</p>
                            <p className="font-semibold">{descriptor.country}</p>
                        </div>
                    )}
                </div>
            </CardContent>
        </Card>
    )
}

